import WorkOpportunitiesContainer from "./containers/WorkOpportunitiesContainer";
export default WorkOpportunitiesContainer;
